import { Config } from "@puckeditor/core"

import { CTA } from "./blocks/cta"
import { Image } from "./blocks/image"
import { ProductList } from "./blocks/product-list"
import { Quote } from "./blocks/quote"
import { RichText } from "./blocks/rich-text"
import { SiteBlocks } from "./index"

/**
 * Block palette for the blog post editor. Pages use the full siteComponents
 * set, articles get the article-oriented subset: prose, media, quotes and
 * curated products. Defined additively on top of SiteBlocks so new blog
 * blocks only extend this map.
 */
export type BlogBlocks = Pick<
  SiteBlocks,
  "RichText" | "Image" | "Quote" | "ProductList" | "CTA"
>

export const blogComponents: Config<BlogBlocks>["components"] = {
  RichText,
  Image,
  Quote,
  ProductList,
  CTA,
}
